<template>
  <layout kind="one_column">
    <v-container fluid pt-0 mt-0 pb-0>
      <v-layout row wrap>
        <v-flex xs12 mb-3>
          <h1 class="max">{{title}}</h1>
        </v-flex>
        <v-flex xs12>
          <div v-if="loaded == 'not_loaded'">{{i18n('Carregando')}} {{description}}...</div>
          <div v-if="loaded == 'error'">{{i18n('Algo errado. Não foi possível carregar os')}} {{description}}.</div>
          <div v-if="loaded == 'not_authorized'">{{i18n('Não foi possível carregar os')}} {{description}}. {{i18n('Você não foi autorizado')}}.</div>
          <div v-if="loaded == 'empty'">{{i18n('Não existem')}} {{description}}.</div>
          <transition name="fade" v-if="loaded == 'ok'">
            <v-card id="transaction-card" class="mb-3" style="border-radius: 10px;">
              <v-container>
                <v-divider class="mt-3" />
                <v-layout row wrap>
                  <item :record="record" v-for="record in records" :key="record.id" @onUpdate="itemUpdated" @onViewChange="itemViewChanged" />
                </v-layout>
              </v-container>
              <v-card-actions>
                <v-layout row wrap>
                  <v-flex xs6 pr-2>
                    <v-btn class="btn-style ma-0 mr-2" block dark @click="loadPreviousPageRecords" v-show="hasPreviousPage"><v-icon left dark>skip_previous</v-icon> {{i18n('Mais Recentes')}}</v-btn>
                  </v-flex>
                  <v-flex xs6 pl-2>
                    <v-btn class="btn-style--secondary ma-0 mr-2" block dark @click="loadNextPageRecords" v-show="hasNextPage">{{i18n('Mais Antigas')}} <v-icon right dark>skip_next</v-icon></v-btn>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </transition>
        </v-flex>
      </v-layout>
    </v-container>
  </layout>
</template>

<script>
import LeftBarLayout from "./layouts/LeftBarLayout"
import CustomersItem from "./CustomersItem"
let customer_keyboard_listener = {}

export default {
  name: 'CustomersList',
  components: { layout: LeftBarLayout, 'item': CustomersItem },
  props: {
    status: {
      type: String,
      default: 'any'
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      records: [],
      loaded: 'not_loaded',
      loading: false,
      last_id: null,
      previous_ids: [],
      opened_records: [], // records on detail view
      showMoreBtn: false
    }
  },
  mounted() {
    this.$root.authenticationStore.redirectIfNotAuthenticated()

    this.loadRecords()
  },
  created() {
    customer_keyboard_listener[this.status] = this.keyboardListener.bind(this)
    window.addEventListener('keydown', customer_keyboard_listener[this.status], false)
  },
  destroyed() {
    window.removeEventListener('keydown', customer_keyboard_listener[this.status], false);
  },
  computed: {
    hasPreviousPage() {
      return this.previous_ids.length > 0
    },
    hasNextPage() {
      return this.records.length == 100
    }
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    itemViewChanged(view_mode, record) {
      if (view_mode === 'detailed') {
        this.opened_records = this.opened_records.concat(record.id)
      } else {
        let index = this.opened_records.findIndex(el => el.id === record.id)
        this.opened_records.splice(index, 1)
      }
    },
    itemUpdated(record) {
      this.loadRecords()
    },
    keyboardListener(e) {
      this.$nextTick(()=>{
        if (this.opened_records.length === 0) {
          let key = e.which || e.keyCode
          if (key === 37) {
            this.loadPreviousPageRecords()
          } else if (key === 39) {
            this.loadNextPageRecords()
          }
        }
      })
    },
    loadRecords() {
      if (this.loading) return
      let successCallback = (response) => {
        this.loading = false
        if (response.body.data) {
          this.records = response.body.data
          if (this.records.length === 0) {
            this.loaded = 'empty'
          } else {
            this.loaded = 'ok'
          }
        } else {
          this.loaded = 'error'
          console.log('successCallback', response)
        }
      }

      let errorCallback = (response) => {
        this.loading = false
        if (response.status === 401) {
          this.loaded = 'not_authorized'
        } else {
          this.loaded = 'error'
        }
        console.log('errorCallback', response)
      }

      let token = this.$cookies.get('api_token')
      this.loading = true
      this.$http.get(this.$root.urls.customer__subject, { params: { status: this.status, last_id: this.last_id }, headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
    },
    loadNextPageRecords() {
      if (this.hasNextPage) {
        this.previous_ids = this.previous_ids.concat(this.last_id)
        this.last_id = this.records[this.records.length - 1]['id']
        this.loadRecords()
        this.moveScrollUp()
      }
    },
    loadPreviousPageRecords() {
      if (this.hasPreviousPage) {
        this.last_id = this.previous_ids.pop()
        this.loadRecords()
        this.moveScrollUp()
      }
    },
    moveScrollUp() {
      setTimeout(function(){
        this.$nextTick(function(){
          this.$vuetify.goTo('#transaction-card', {duration: 800, offset: 100, easing: 'easeInOutCubic'})
        })
      }.bind(this), 100)
    }
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/CustomersList.vue